import React from 'react'

const ErroBackendPage = props => {
    return (
        <div className="backEndError">
            <h3 className="backEndErrorText">Erro ao acessar o servidor</h3>
        </div>
    )
}

export default ErroBackendPage
